export const SET_ERROR = "SET_ERROR";

export const SET_WALLET = "SET_WALLET";
export const RESET_WALLET = "RESET_WALLET";

export const SET_LOADING = "SET_LOADING";

export const SET_LOGIN_LOADING = "SET_LOGIN_LOADING";

export const SET_RECORDS = "SET_RECORDS";

export const SET_ADMIN = "SET_ADMIN";